import { isArray } from 'lodash';

const CONTENT_PROPS = ['description', 'hyperlink', 'location', 'content_links', 'withEmail', 'is_directory'];

/**
 * Returns true if the item have contents
 * @param  {Number}  item       Item
 * @param  {array}   ignore     List of fields to ignore
 * @return {Boolean}
 */
export function itemHasContent(item, ignore = []) {
    for (let propName of CONTENT_PROPS) {
        let value = item[propName];
        if (!ignore.includes(propName) && value && (!isArray(value) || value.length)) {
            return true;
        }
    }
    return false;
}
